import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveCommentRequestFailure({ uuid }) {
      const req = getState().find(({ comment }) => comment.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveCommentRequestPending({ uuid }) {
      const req = getState().find(({ comment }) => comment.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveCommentRequestSuccess({ uuid }) {
      const req = getState().find(({ comment }) => comment.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
